import React from "react";
import { Route } from "react-router-dom";
import { ProjectCategoryCard } from "./ProjectCategoryCard";
import { ProjectCategoryEditDialog } from "./project-category-edit-dialog/ProjectCategoryEditDialog";
import { ProjectCategoryUIProvider } from "./ProjectCategoryUIContext";
import { PrivateRoute } from "../../../PrivateRoute";
import { RoleChecker } from "../../../RoleChecker";
import { ProjectCategoryDeleteDialog } from "./project-category-delete-dialog/ProjectCategoryDeleteDialog";

export function ProjectCategoryPage({ history }) {
  const projectCategoryUIEvents = {
    newProjectCategoryButtonClick: () => {
      history.push("/_distribution/category/new");
    },
    openEditProjectCategoryPage: (id) => {
      history.push(`/_distribution/category/${id}/edit`);
    },
    openDeleteProjectCategoryPage: (id) => {
      history.push(`/_distribution/category/${id}/delete`);
    },
  };

  return (
    <ProjectCategoryUIProvider projectCategoryUIEvents={projectCategoryUIEvents}>
      <PrivateRoute
        role={RoleChecker("Create", "project")}
        component={ProjectCategoryEditDialog}
        path="/_distribution/category/new"
      />
      <PrivateRoute
        role={RoleChecker("Edit", "project")}
        component={ProjectCategoryEditDialog}
        path="/_distribution/category/:id/edit"
      />
      <PrivateRoute
        role={RoleChecker("Edit", "project")}
        component={ProjectCategoryDeleteDialog}
        path="/_distribution/category/:id/delete"
      />

       <Route path="/_distribution/category/new">
        {({ history, match }) => (
          <ProjectCategoryEditDialog
            show={match != null}
            onHide={() => {
              history.push("/_distribution/category");
            }}
          />
        )}
      </Route>
      <Route path="/_distribution/category/:id/edit">
        {({ history, match }) => 
        (
          <ProjectCategoryEditDialog
            show={match != null}
            id={match && match.params.id}
            onHide={() => {
              history.push("/_distribution/category");
            }}
          />
        )
        }
      </Route>
      <Route path="/_distribution/category/:id/delete">
        {({ history, match }) => (
          <ProjectCategoryDeleteDialog
            show={match != null}
            id={match && match.params.id}
            onHide={() => {
              history.push("/_distribution/category");
            }}
          />
        )}
      </Route>

      <ProjectCategoryCard />
    </ProjectCategoryUIProvider>
  );
}
